import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable, from, of } from "rxjs";
import { UserService } from "../services/user.service";
import { map, switchMap } from "rxjs/operators";

@Injectable({ providedIn: 'root' })
// protects routes from unauthenticated users
export class AuthGuard {
  constructor(private router: Router, private userService: UserService) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    let hasRoles = route.data['roles'] as string[];
    return from(this.userService.init()).pipe(
      switchMap(() => {
        if (hasRoles) {
          for (let role of hasRoles) {
            if (!this.userService.IsInRole(role)) {
              return of(false);
            }
          }
        }
        return this.isSignedIn(state.url);
      })
    );
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    let hasRoles = route.data['roles'] as string[];
    return from(this.userService.init()).pipe(
      switchMap(() => {
        if (hasRoles) {
          for (let role of hasRoles) {
            if (!this.userService.IsInRole(role)) {
              return of(false);
            }
          }
        }
        return this.isSignedIn(state.url);
      })
    );
  }

  isSignedIn(returnUrl?: string): Observable<boolean> {
    return from(this.userService.init()).pipe(
      switchMap(() => {
        let isSignedIn = this.userService.isSignedIn;
        if (!isSignedIn) {
          const queryParams = returnUrl && returnUrl !== '/' ? { returnUrl } : undefined;
          this.router.navigate(['/identity/signin'], { queryParams });
        }
        return of(isSignedIn);
      })
    );
  }
}
